var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { getChainByKey } from '@lifi/sdk';
import { createContext, useContext, useEffect, useId, useMemo } from 'react';
import { setDefaultSettings, useSettingsStoreContext } from '../../stores';
import { formatAmount } from '../../utils';
const initialContext = {
    disabledChains: [],
    elementId: '',
};
const WidgetContext = createContext(initialContext);
export const useWidgetConfig = () => useContext(WidgetContext);
export const WidgetProvider = (_a) => {
    var { children } = _a, _b = _a.config, _c = _b === void 0 ? {} : _b, { fromChain, fromToken, toChain, toToken, fromAmount } = _c, config = __rest(_c, ["fromChain", "fromToken", "toChain", "toToken", "fromAmount"]);
    const settingsStoreContext = useSettingsStoreContext();
    const elementId = useId();
    const value = useMemo(() => {
        var _a, _b, _c, _d, _e, _f;
        try {
            const searchParams = Object.fromEntries(new URLSearchParams(window === null || window === void 0 ? void 0 : window.location.search));
            // Prevent using fromToken/toToken params if chain is not selected
            ['from', 'to'].forEach((key) => {
                if (searchParams[`${key}Token`] && !searchParams[`${key}Chain`]) {
                    delete searchParams[`${key}Token`];
                }
            });
            return Object.assign(Object.assign({}, config), { fromChain: (searchParams.fromChain &&
                    isNaN(parseInt(searchParams.fromChain, 10))) ||
                    typeof fromChain === 'string'
                    ? (_b = getChainByKey((_a = (searchParams.fromChain || fromChain)) === null || _a === void 0 ? void 0 : _a.toLowerCase())) === null || _b === void 0 ? void 0 : _b.id
                    : (searchParams.fromChain &&
                        !isNaN(parseInt(searchParams.fromChain, 10))) ||
                        typeof fromChain === 'number'
                        ? parseInt(searchParams.fromChain, 10) || fromChain
                        : undefined, toChain: (searchParams.toChain && isNaN(parseInt(searchParams.toChain, 10))) ||
                    typeof toChain === 'string'
                    ? (_d = getChainByKey((_c = (searchParams.toChain || toChain)) === null || _c === void 0 ? void 0 : _c.toLowerCase())) === null || _d === void 0 ? void 0 : _d.id
                    : (searchParams.toChain &&
                        !isNaN(parseInt(searchParams.toChain, 10))) ||
                        typeof toChain === 'number'
                        ? parseInt(searchParams.toChain, 10) || toChain
                        : undefined, fromToken: ((_e = searchParams.fromToken) === null || _e === void 0 ? void 0 : _e.toLowerCase()) || (fromToken === null || fromToken === void 0 ? void 0 : fromToken.toLowerCase()), toToken: ((_f = searchParams.toToken) === null || _f === void 0 ? void 0 : _f.toLowerCase()) || (toToken === null || toToken === void 0 ? void 0 : toToken.toLowerCase()), fromAmount: typeof searchParams.fromAmount === 'string' &&
                    !isNaN(parseFloat(searchParams.fromAmount))
                    ? formatAmount(searchParams.fromAmount)
                    : fromAmount, elementId });
        }
        catch (e) {
            console.warn(e);
            return Object.assign(Object.assign({}, config), { elementId });
        }
    }, [config, elementId, fromAmount, fromChain, fromToken, toChain, toToken]);
    useEffect(() => {
        setDefaultSettings(settingsStoreContext, value);
    }, [settingsStoreContext, value]);
    return (_jsx(WidgetContext.Provider, Object.assign({ value: value }, { children: children })));
};
